<template>
  <div class="vote-main">
    <!--    主题-->
    <div class="header flex-between">
      <span>{{data.name}}</span>
      <i class="iconfont iconx" v-if="showClose" style="color:#9C9C9C;font-size: 15px;font-weight: bold"
         @click.stop="handleClickDelete"></i>
    </div>
    <!--描述-->
    <div class="desc flex-start">
      <div class="type">
        {{data.type=='single'?'单选':'多选'}}
      </div>
      <span class="desc-text"> {{data.participant_count}} 人参与·{{  scenario=='new'?(data.expiry > 24 ? `还有 ${data.expiry / 24} 天结束` : `还有 ${data.expiry} 小时结束`):timeFormat(data.end_at)}}</span>
    </div>
    <!--选项-->
    <div class="option-box flex-start" v-for="(item,index) in scenario=='list'?data.options.slice(0,3):data.options"
         :key="index+'option'"
         @click.stop="handleClickSelect(item)">
      <i :class="['iconfont',selectedId.includes(item.id)?'iconxuanzhong': 'iconweixuanzhong']"
         v-if="data.my_choices.length==0&&!end" style="font-size: 14px"
         :style="{color:selectedId.includes(item.id)?'#FF6644':className(scenario,data.my_choices.includes(item.id),'content',data.my_choices.length>0)}"></i>
      <p class="flex-between box" style="align-items: flex-end">
        <span style="flex:1;line-height: 16px;font-size: 14px" :class="{'active-content':selectedId.includes(item.id)}"
              :style="{color:className(scenario,data.my_choices.includes(item.id),'content',data.my_choices.length>0),fontWeight:data.my_choices.includes(item.id)?600:400}">{{item.content}}</span>
        <span v-if="data.my_choices.length>0||end"
              :style="{color:className(scenario,data.my_choices.includes(item.id),'num',data.my_choices.length>0)}">{{item.choose_count}} ({{total == 0 ? 0 : ((item.choose_count / total ) * 100).toFixed(0)}}%)</span>
      </p>
      <div class="proportion-all" v-if="data.my_choices.length>0||end"
           :style="{backgroundColor:data.my_choices.includes(item.id)?'#FFEAE5':'#ECECEC'}">
        <div class="proportion"
             :style="{backgroundColor:data.my_choices.includes(item.id)?'#f64':'#CFCFCF',width:total == 0 ? 0 : ((item.choose_count / total ) * 100).toFixed(0)+'%'}"></div>
      </div>
    </div>

    <!--    底部按钮-->

    <div class="flex-center bottom-btn-box">
      <div class="bottom-btn" v-if="scenario=='new'" @click="handleClickEdit">
        <i class="iconfont iconbianji1" style="font-size: 12px;margin-right: 6px"></i>
        <span>编辑投票</span>
      </div>
      <div class="bottom-btn vote" v-if="scenario=='detail'"
           @click="handleClickSubmit((timeFormat(data.end_at)==='投票已结束'),(data.my_choices.length>0))"
           :style="{backgroundColor:bottomBackgroundColor}">
        <span>{{end?'已结束':(data.my_choices.length>0)?'已投票':'投票'}}</span>
      </div>
    </div>

    <!--    底部文案-->
    <div v-if="scenario=='list'" class="bottom-text-box">
      {{end?'已结束':(data.my_choices.length>0?'已投票':'进入详情投票')}}
    </div>
  </div>
</template>

<script>
  import moment from "moment"
  import bbs from "../../../api/api-list/bbs";
  import {mapMutations} from 'vuex'
  import {loginMixin} from '../../../assets/js/mixin/global'

  export default {
    name: "vote",
    props: {
      data: [Object],
      showClose: [Boolean],
      scenario: [String],
      toDetail: [Function]
    },
    data() {
      return {
        selectedId: []
      }
    },
    mixins: [loginMixin],
    computed: {
      total() {
        return this.data.options.map(a => a.choose_count).reduce((a, b) => a + b)
      },
      bottomBackgroundColor() {
        return ((this.timeFormat(this.data.end_at) === '投票已结束') || this.data.my_choices.length > 0) ? '#CFCFCF' : this.selectedId.length > 0 ? '#FF6644' : '#FF9279'
      },
      end() {
        return this.timeFormat(this.data.end_at) === '投票已结束'
      }
    },
    methods: {
      ...mapMutations('community', ['setVote']),
      //删除操作
      handleClickDelete() {
        this.$createDialog({
          type: 'confirm',
          title: '提示',
          content: '投票删除后将不可恢复，确认删除？',
          confirmBtn: {
            text: '删除',
            active: true,
            disabled: false,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '取消',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: async () => {
            let res = await bbs.deleteVote(this.data.id)
            if (res.code === 1000) {
              this.$createToast({
                txt: '删除成功',
                time: 500,
                type: 'txt'
              }).show()
              setTimeout(() => {
                this.setVote(null)
              }, 500)
            }
          },
          onCancel: async () => {

          }
        }).show()

      },
      //选择操作
      handleClickSelect(item) {
        if (this.scenario === 'new') {
          return;
        }
        if (this.scenario === 'list') {
          this.toDetail()
          return;
        }
        if (this.data.my_choices.length > 0 || this.timeFormat(this.data.end_at) == '投票已结束') {
          return
        }
        if (!this.alreadyLogged) {
          this.needLogin()
          return;
        }
        if (this.data.type == "single") {
          this.selectedId = [item.id]
        } else {
          if (this.selectedId.includes(item.id)) {
            this.selectedId = this.selectedId.filter(good => good != item.id)
          } else {
            this.selectedId = [...new Set([...this.selectedId, item.id])]
          }
        }
      },
      //编辑
      handleClickEdit() {
        this.$emit("on-edit")
      },
      //投票
      async handleClickSubmit(end, isSelect) {
        if (end || isSelect) {
          return
        }
        let res = await bbs.onVote(this.$route.params.token, this.data.id, {choose_ids: this.selectedId})
        if (res.code === 1000) {
          this.$emit("on-vote", this.selectedId)
          this.selectedId = []
          this.$createToast({
            txt: '投票成功',
            time: 500,
            type: 'txt'
          }).show()
        } else {
          this.$createToast({
            txt: res.message,
            time: 500,
            type: 'txt'
          }).show()
        }

      },
      timeFormat(time) {
        //结束时间的时间戳
        let localTime = moment.utc(time).toDate();
        let end = moment(localTime).valueOf()
        //当前时间的时间戳
        let now = moment().valueOf()
        let difference = end - now
        if (difference > 0) {
          let day = Math.floor(difference / (60 * 60 * 24 * 1000))
          let hours = Math.floor(difference / (60 * 60 * 1000))
          let minutes = Math.floor(difference / (60 * 1000))
          if (day > 0) {
            return `还有 ${day + (difference > (day * 24 * 60 * 60 * 1000 + 12 * 60 * 60 * 1000) ? 1 : 0)} 天结束`
          } else {
            if (hours > 0) {
              return `还有 ${hours + (difference > (hours * 60 * 1000 + 30 * 60 * 1000) ? 1 : 0)} 小时结束`
            } else {
              return `还有 ${minutes == 0 ? 1 : minutes} 分钟结束`
            }
          }
        } else {
          return '投票已结束'
        }
      },
      className(scenario, selected, type, isSelect) {
        let end = this.timeFormat(this.data.end_at) === '投票已结束'
        if (scenario == 'new') {
          return '#9c9c9c'
        }
        if(end){
          return selected?'#404040':'#9c9c9c'
        }
        if (scenario == 'list') {
          if (selected) {
            return '#404040'
          } else {
            return '#9c9c9c'
          }
        } else {
          if (type == 'content') {
            if (isSelect) {
              if (selected) {
                return '#404040'
              } else {
                return '#9c9c9c'
              }
            } else {
              return  "#9c9c9c"
            }
          } else {
            if (isSelect) {
              if (selected) {
                return '#404040'
              } else {
                return '#9c9c9c'
              }
            } else {
              return '#9c9c9c'
            }
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .vote-main {
    padding: 16px 12px;
    background: #F9F9F9;
    margin-bottom: 8px;
    border-radius: 4px;

    .box {
      flex: 1;
    }

    .header {
      font-size: 16px;
      font-weight: 700;
      color: #404040;
      line-height: 22px;

      span {
        font-weight: 700;
      }
    }

    .desc {
      padding: 8px 0 16px 0;
      border-bottom: 1px solid #ececec;
      margin-bottom: 7px;

      .type {
        width: 36px;
        height: 20px;
        border-radius: 2px;
        border: 1px solid #9C9C9C;
        color: #9C9C9C;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        margin-right: 8px;
      }

      .desc-text {
        font-size: 12px;
        font-weight: 400;
        color: #9C9C9C;
        line-height: 12px;
      }
    }

    .option-box {
      padding: 10px 0;
      color: #9c9c9c;
      font-size: 14px;
      position: relative;

      & > i {
        font-size: 14px;
      }

      .proportion-all {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 6px;
        border-radius: 3px;
        background: #ECECEC;
      }

      .proportion {
        width: 50%;
        height: 6px;
        border-radius: 3px;
        background: #CFCFCF;
      }

      i {
        font-size: 12px;
        margin-right: 8px;
      }

      .list-false-content {
        color: #9c9c9c;
      }

      .list-false-num {
        color: #9c9c9c;
      }

      .list-true-content {
        color: #404040;
        font-weight: 600;
      }

      .list-true-num {
        color: #404040;
      }

      .active-content {
        color: #404040;
        font-weight: 600 !important;
      }
    }

    .bottom-btn-box {
      margin-top: 20px;

      .bottom-btn {
        width: 100px;
        height: 30px;
        background: #606060;
        border-radius: 4px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;

        & > i {
          font-size: 12px;
          margin-right: 6px;
        }
      }

      .vote {
        background: #FF9279;
      }
    }

    .bottom-text-box {
      text-align: center;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 17px;
      font-size: 12px;
    }

  }
</style>